import * as Icons from "lucide-react";
import { SERVICE_CATEGORIES } from "@/lib/site";

export const Services = () => (
  <section id="services" className="relative py-24 lg:py-32" data-testid="services-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-12">
      <div className="max-w-3xl reveal">
        <div className="text-xs uppercase tracking-[0.2em] font-semibold text-brand-purple">What we do</div>
        <h2 className="section-heading text-3xl sm:text-4xl lg:text-5xl mt-3 text-slate-900">
          Everything your business needs — <span className="text-gradient">under one roof</span>
        </h2>
        <p className="mt-4 text-slate-600 text-lg max-w-2xl">
          From websites and software to AI automation, cloud platforms and marketing — we deliver every layer of your digital stack.
        </p>
      </div>

      <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {SERVICE_CATEGORIES.map((cat, idx) => {
          const Icon = Icons[cat.icon];
          return (
            <div
              key={cat.id}
              className="group card-lift card-tilt holo-card rounded-2xl border border-slate-100 soft-shadow flex flex-col overflow-hidden reveal"
              style={{ transitionDelay: `${(idx % 4) * 70}ms` }}
              data-testid={`service-card-${cat.id}`}
            >
              {cat.image && (
                <div className="relative -mx-px -mt-px h-32 overflow-hidden">
                  <img
                    src={cat.image}
                    alt={cat.alt || cat.title}
                    loading="lazy"
                    width="800"
                    height="400"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-white via-white/40 to-transparent" />
                </div>
              )}
              <div className="p-6 flex flex-col flex-1">
              <div className={`w-12 h-12 rounded-xl bg-gradient-to-br ${cat.color} flex items-center justify-center text-white mb-5 shadow-lg shadow-purple-500/20 group-hover:scale-110 transition-transform`}>
                <Icon className="w-6 h-6" />
              </div>
              <h3 className="font-heading font-bold text-lg text-slate-900">{cat.title}</h3>
              <p className="text-sm text-slate-500 mt-1">{cat.tagline}</p>
              <ul className="mt-4 space-y-1.5 text-[13px] text-slate-600 flex-1">
                {cat.items.slice(0, 6).map((it) => (
                  <li key={it} className="flex items-start gap-2">
                    <span className="mt-1.5 w-1 h-1 rounded-full bg-brand-gradient shrink-0" />
                    {it}
                  </li>
                ))}
                {cat.items.length > 6 && (
                  <li className="text-slate-400 italic">+{cat.items.length - 6} more</li>
                )}
              </ul>
              <a href="#contact" className="mt-5 inline-flex items-center gap-1 text-sm font-semibold text-slate-900 group-hover:text-brand-purple transition-colors">
                Learn more <Icons.ArrowRight className="w-4 h-4" />
              </a>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  </section>
);
